import axios from 'axios';

const API_BASE_URL = 'http://localhost:5000/Admins';  // Adjust this as necessary

const createAdmin = async (email, password) => {
  try {
    console.log('Creating new Admin:', email, password);
    const response = await axios.post(API_BASE_URL,  email, password );  // Send data as an object
    console.log('Successfully created new Admin:', response.data);
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error creating new Admin:', error.response?.data.message || error.message);
    return { success: false, message: error.response?.data.message || error.message };
  }
};

const deleteAdmin = async (uid) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/${uid}`);
    console.log('Successfully deleted Admin');
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error deleting Admin:', error.response?.data || error.message);
    return { success: false, message: error.response?.data || error.message };
  }
};

const deleteAdminByEmail = async (email) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/email/${email}`);
    console.log('Successfully deleted Admin with email:', email);
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error deleting Admin by email:', error.response?.data || error.message);
    return { success: false, message: error.response?.data || error.message };
  }
};

const disableAdmin = async (uid) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/${uid}/disable`);
    console.log('Successfully disabled Admin');
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error disabling Admin:', error.response?.data || error.message);
    return { success: false, message: error.response?.data || error.message };
  }
};

const enableAdmin = async (uid) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/${uid}/enable`);
    console.log('Successfully enabled Admin');
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error enabling Admin:', error.response?.data || error.message);
    return { success: false, message: error.response?.data || error.message };
  }
};

export { createAdmin, deleteAdmin, disableAdmin, enableAdmin, deleteAdminByEmail };
